module.exports = __webpack_public_path__ + "img/01.5a814ea7.jpg";